/**
 * Utility functions for step management
 */

/**
 * Generate CSS class names for step containers
 */
export const getStepClassNames = (
  isActive: boolean,
  isDisabled: boolean,
  isCompleted: boolean,
  baseClass = 'step-container'
): string => {
  const classes = [baseClass];

  if (isActive) {
    classes.push('active');
  }

  if (isDisabled) {
    classes.push('disabled');
  }

  if (isCompleted) {
    classes.push('completed');
  }

  return classes.join(' ');
};

/**
 * Handle keyboard navigation for interactive elements
 */
export const handleKeyboardNavigation = (
  event: React.KeyboardEvent,
  callback: () => void,
  keys: string[] = ['Enter', ' ']
): void => {
  if (keys.includes(event.key)) {
    event.preventDefault();
    callback();
  }
};

/**
 * Calculate pixels per rem for dynamic height calculations
 */
export const getPixelsPerRem = (): number =>
  parseFloat(getComputedStyle(document.documentElement).fontSize);
